import { AppThunk } from '../../../../store/types';
import { setPlayerRate } from '../../../../store/general/actions';
import { isHoverAutoPause } from '../../../../store/general/selectors';
import { UserSettingEffects } from '../../../../effects/userSettingEffects';
import { AudioPlayerManager } from '../../../../effects/audioPlayer/audioPlayerManager';

export class PlaybackSettingsEvents {

  public static onHoverAutoPauseChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      const pause = isHoverAutoPause(getState());
      UserSettingEffects.setHoverAutoPause(!pause);
    }
  }

  public static onRateChange(rate: number): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      AudioPlayerManager.getInstance().setPlaybackRate(rate);
      dispatch(setPlayerRate(rate));
    }
  }

  public static onAutoSpeechRateChange(rate: number): AppThunk {
    return () => {
      UserSettingEffects.setAutoSpeechRate(rate);
    }
  }

}
